import React from "react";
import ReactModal from "react-modal";
import "./CloseReasonModal.css";

// Theme colors (match the app's dark theme + orange accent)
const ACCENT = "#eb951f";

const modalStyles = {
  overlay: {
    background: "rgba(0, 0, 0, 0.6)",
    zIndex: 1000,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    background: "#121212",
    color: "#cfcfcf",
    border: "1px solid #2a2a2a",
    borderRadius: "8px",
    padding: "0",
    width: "460px",
    maxWidth: "90%",
  },
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "18px 20px",
  borderBottom: "1px solid #2a2a2a",
};

const closeBtnStyle = {
  background: "transparent",
  border: "none",
  color: "#999",
  fontSize: "22px",
  lineHeight: "1",
  cursor: "pointer",
};

const selectStyle = {
  width: "100%",
  background: "#000",
  color: "#fff",
  border: "1px solid #444",
  borderRadius: "4px",
  padding: "10px",
  marginTop: "8px",
  outline: "none",
};

const inputStyle = {
  width: "100%",
  background: "#000",
  color: "#fff",
  border: "1px solid #444",
  borderRadius: "4px",
  padding: "10px",
  marginTop: "8px",
  outline: "none",
  boxSizing: "border-box",
};

const footerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  padding: "16px 20px",
  borderTop: "1px solid #2a2a2a",
};

const cancelBtnStyle = {
  background: "transparent",
  color: "#cfcfcf",
  border: "1px solid #555",
  borderRadius: "4px",
  padding: "8px 18px",
  cursor: "pointer",
  fontWeight: 600,
};

const confirmBtnBase = {
  background: ACCENT,
  color: "#121212",
  border: "none",
  borderRadius: "4px",
  padding: "8px 18px",
  fontWeight: 600,
};

// Controlled presentational modal. Parent owns selectedReasonId + handlers.
const CloseReasonModal = ({
  isOpen,
  reasons = [],
  selectedReasonId,
  onChange,
  freeText = "",
  onFreeTextChange,
  onConfirm,
  onCancel,
}) => {
  const selected = reasons.find(
    (r) => String(r.id) === String(selectedReasonId)
  );
  const hasFreeText = !!(freeText && freeText.trim());
  // Confirm allowed if a custom reason is typed OR a dropdown reason is selected.
  const canConfirm = hasFreeText || !!selectedReasonId;
  const confirmBtnStyle = {
    ...confirmBtnBase,
    cursor: canConfirm ? "pointer" : "not-allowed",
    opacity: canConfirm ? 1 : 0.5,
  };
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onCancel}
      style={modalStyles}
      ariaHideApp={false}
    >
      <div style={headerStyle}>
        <h5 style={{ margin: 0, color: "#fff", fontSize: "18px" }}>
          Select Close Reason
        </h5>
        <button type="button" style={closeBtnStyle} onClick={onCancel}>
          &times;
        </button>
      </div>
      <div style={{ padding: "20px" }}>
        <label style={{ color: "#bbb", fontSize: "14px" }}>
          Close Reason <span style={{ color: "#ff4d4f" }}>*</span>
        </label>
        <select
          style={selectStyle}
          value={selectedReasonId || ""}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="" disabled>
            Select a reason
          </option>
          {reasons.map((r) => (
            <option key={r.id} value={r.id}>
              {r.reason}
            </option>
          ))}
        </select>
        {selected && selected.auto_disposition && (
          <div style={{ marginTop: "14px", color: "#999", fontSize: "14px" }}>
            Auto Disposition:{" "}
            <span style={{ color: ACCENT, fontWeight: 600 }}>
              {selected.auto_disposition}
            </span>
          </div>
        )}
        <div style={{ marginTop: "16px" }}>
          <label style={{ color: "#bbb", fontSize: "14px" }}>
            Custom Reason (optional)
          </label>
          <input
            type="text"
            className="close-reason-input"
            maxLength={50}
            style={inputStyle}
            value={freeText}
            placeholder="Type a custom reason (max 50 chars)"
            autoComplete="off"
            onChange={(e) => onFreeTextChange(e.target.value)}
          />
          {hasFreeText && (
            <div style={{ marginTop: "6px", color: "#999", fontSize: "12px" }}>
              This custom reason will be used instead of the selected reason.
            </div>
          )}
        </div>
        {reasons.length === 0 && (
          <div style={{ marginTop: "14px", color: "#ff4d4f", fontSize: "14px" }}>
            No reasons available. Cannot close the ticket.
          </div>
        )}
      </div>
      <div style={footerStyle}>
        <button type="button" style={cancelBtnStyle} onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          style={confirmBtnStyle}
          disabled={!canConfirm}
          onClick={onConfirm}
        >
          Confirm Close
        </button>
      </div>
    </ReactModal>
  );
};

export default CloseReasonModal;
